import Hero from '../Hero'
import SocialProof from 'components/ckan/SocialProof.jsx'
import ValuePropositions from 'components/ckan/ValuePropositions.jsx'
import Features from 'components/ckan/Features.jsx'
import Contact from 'components/ckan/Contact.jsx'
import Contact2 from 'components/ckan/Contact2.jsx'
import HowItWorks from '../HowItWorks'
import Faq from 'components/ckan/development/Faq.jsx'
import CaseStudiesSection from 'components/ckan/CaseStudiesSection';

export default function Index({casestudies}) { 
  const featured = [
  {
    title: "Workflow Automation",
    text: "Speed up your work by automating tedious tasks that you are currently working through manually.",
    icon: "/assets/icons/robot.json",
  },
    {
    title: "Data Federation", 
    text: "Link your CKAN instances to those of other organizations so that you can collaborate and share data between you without compromising your data's security.",
    icon: "/assets/icons/copy.json",
  },
  {
    title: "Access Permissioning",
    text: "Keep your data secure by defining who can see what data and when. Easily control who can access your data and what they can do with it.",
    icon: "/assets/icons/padlock.json",
  },
  {
    title: "Schemas",
    text: "Enhance data quality by creating a blueprint for the form your data will take. Ensure that your data description is accurate and consistent.",
    icon: "/assets/icons/diagram.json",
  },
  {
    title: "Integration",
    text: "Keep using the systems you’re familiar with by joining them seamlessly with CKAN. Integrate CKAN with other systems with ease.",
    icon: "/assets/icons/hexagonal.json",
  },
  {
    title: "Standards",
    text: "Make sure each and every data field consistently contains the information you need. Ensure that your data is accurate, consistent, and reliable.",
    icon: "/assets/icons/standards.json",
  },
] 

const values= [
  {
    title: "Ready to go",
    text: "CKAN can be installed straight out of the box, delivering live instances in minutes.",
  },
    {
    title: "Infinite possibility",
    text: "We are available to extend and tailor your installation for as long as you need.",
  },
    {
    title: "Cost-effective",
    text: "Avoid vendor lock-in and save money with free-to-use, open-source software.",
  },
]

const steps=[
  {
    title: "TECHNICAL ANALYSIS",
    text: "First, we carry out a technical analysis to identify where you fall on the data management maturity model and appraise your existing systems.",
    icon: "/assets/icons/magnify.json",
  },
    {
    title: "IDENTIFY YOUR NEEDS",
    text: "Next, you tell us your area of need - publishing data openly, managing internal data etc., and we work together to define your goals.",
    icon: "/assets/icons/speech-bubble.json",
  },
    {
    title: "CKAN SOLUTION",
    text: "We set up a CKAN solution that is ready to go straight out of the box. This takes minutes.",
    icon: "/assets/icons/puzzle.json",
  },
    {
    title: "CUSTOMIZATION",
    text: "We work with you to customize and extend your solution, adding features such as data versioning and secure data sharing.",
    icon: "/assets/icons/expand.json",
  },
    {
    title: "EFFECTIVE DATA STRATEGY",
    text: "We help you create an effective, sustainable data strategy and provide guideance on agile data practices to ensure your success.",
    icon: "/assets/icons/bubble-chat.json",
  },
    {
    title: "DATA ENGINEERING SERVICES",
    text: "Finally, we offer to take over the relevant data engineering services for your system, giving you more time to focus on achieving your goals.",
    icon: "/assets/icons/handshake.json",
  },

]
  return (
    <div className="flex flex-wrap justify-center">
      <div className="max-w-7xl w-full">
        <Hero 
        topTitle="CKAN Development"
        title="Tailor CKAN to your needs. Get expert help from the team that built it."
        subtitle="Don’t change your processes to fit a new technology. Integrate existing workflows for a solution that works around you."
        ctaOffer="See other CKAN services"
        ctaUrl="/solutions/ckan#services"/>
        </div>
        <SocialProof />
              <div className="max-w-7xl w-full">
        <ValuePropositions topTitle="What makes CKAN the leading data management software?" title="Full customizability for your business to process, catalog, and standardize data to your needs. Secure, reliable, and integrates with existing systems." valuePropositions={values}/>
      </div>
      <Features topTitle="Fully-featured, mature, and 100% open source platform" title="CKAN has an evolving micro-service setup that makes it easy to use what you need, to scale up or down and easily adapt to evolving requirements and needs. We can help you tailor CKAN to your needs." featuredItems={featured}/>
      <div className="max-w-7xl w-full">
        <HowItWorks topTitle="How it works" steps={steps} />
        <CaseStudiesSection blogs={casestudies} subtitle="CKAN DEVELOPMENT" catalog="ckan-development" />
      
        <Faq />
      </div>
        <Contact />
        <div className="md:hidden">
          <Contact2 />
        </div>
    </div>
  )
}